import { useActiveApi } from '@api/tutor-kanban/active.hook'
import { parseFilterParams } from '@hooks/tutor-kanban/filters/parse-filter-params'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware((to) => {
  const params = parseFilterParams(to.query)

  void useActiveApi({ params })
})
